import { type ComputedRef, type ShallowRef, computed, shallowRef } from 'vue';

const stack: ShallowRef<HTMLDialogElement[]> = shallowRef([]);
const topModal = computed(() => stack.value.at(-1) ?? null);

function registerModal(dialog: HTMLDialogElement) {
  if (!stack.value.includes(dialog)) stack.value = [...stack.value, dialog];
}

function unregisterModal(dialog: HTMLDialogElement) {
  stack.value = stack.value.filter((entry) => entry !== dialog);
}

export function useModalStack(): {
  topModal: ComputedRef<HTMLDialogElement | null>;
  registerModal: (dialog: HTMLDialogElement) => void;
  unregisterModal: (dialog: HTMLDialogElement) => void;
} {
  return { topModal, registerModal, unregisterModal };
}
